var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "reply-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg reply",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "reply") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.64,8.73H13.09v2.91H27.64V29.09H4.36V11.64H7.27v5.81h2.91V5.82h8.73V0H7.27V8.73H4.36a2.92,2.92,0,0,0-2.91,2.91V29.09A2.92,2.92,0,0,0,4.36,32H27.64a2.92,2.92,0,0,0,2.91-2.91V11.64A2.92,2.92,0,0,0,27.64,8.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.393bc89210adeb8e2bb03c9bd0c39df3.svg";
export { ForwardRef as ReactComponent };